import { BuilderSettings } from '../redux/types/builders';

// Shared by OtpVerification (routes to TextVerify or skips it) and EmailVerify (whether to attach
// the inquiryId to the register payload) — kept in one place so the two gates can't drift apart.
export const requiresPersonaVerification = (builderSettings: BuilderSettings): boolean =>
  Boolean(builderSettings.license_scanning_active || builderSettings.min_age_verification_active);
